import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { submitRating, fetchRatingSummary, getMyRating } from "@/lib/api";
import { toast } from "sonner";

// Genuine rating widget: visitors rate vspo, the real average feeds the
// AggregateRating structured data (no fabricated reviews).
export const RatingWidget = ({ onSummary }) => {
  const [summary, setSummary] = useState({ average: 0, count: 0 });
  const [mine, setMine] = useState(getMyRating());
  const [hover, setHover] = useState(0);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetchRatingSummary().then((s) => {
      setSummary(s);
      if (onSummary) onSummary(s);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rate = async (stars) => {
    if (busy) return;
    setBusy(true);
    setMine(stars);
    try {
      const s = await submitRating(stars);
      setSummary(s);
      if (onSummary) onSummary(s);
      toast.success("Merci pour votre note !");
    } catch (e) {
      toast.error("Impossible d'enregistrer votre note pour le moment.");
    } finally {
      setBusy(false);
    }
  };

  const active = hover || mine;

  return (
    <div className="rounded-2xl border border-border bg-card p-5" data-testid="rating-widget">
      <h2 className="font-display text-lg font-bold text-foreground">Notez vspo</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        Votre avis nous aide à améliorer le GPS pour voitures sans permis.
      </p>
      <div className="mt-3 flex items-center gap-1" role="radiogroup" aria-label="Noter vspo de 1 à 5 étoiles">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => rate(n)}
            onMouseEnter={() => setHover(n)}
            onMouseLeave={() => setHover(0)}
            disabled={busy}
            aria-label={`${n} étoile${n > 1 ? "s" : ""}`}
            aria-checked={mine === n}
            role="radio"
            data-testid={`rating-star-${n}`}
            className="rounded-md p-0.5 transition-transform hover:scale-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary disabled:opacity-60"
          >
            <Star
              className="h-7 w-7"
              style={{
                fill: n <= active ? "hsl(38 92% 50%)" : "transparent",
                color: n <= active ? "hsl(38 92% 50%)" : "hsl(var(--muted-foreground))",
              }}
            />
          </button>
        ))}
      </div>
      <p className="mt-2 text-xs text-muted-foreground" data-testid="rating-summary">
        {summary.count > 0
          ? `Note moyenne ${summary.average}/5 · ${summary.count} avis`
          : "Soyez le premier à donner votre avis."}
      </p>
    </div>
  );
};
